import { findIn } from '../../app/helpers/entity'
import { ACCESSORY_TYPES } from '../../app/core/constants'

/**
 * AddAccessoryCtrl controller
 * Add/edit Subscription Accessory
 */

/**
 * AddAccessoryCtrl controller
 *
 * @class AddAccessoryCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @ngdoc controller
 * @name mwApp/packages.controller:AddAccessoryCtrl
 */
/* @ngInject */

export default function AddAccessoryCtrl ($scope, $state, $location, accessory, networkCurrencies, pckg) {
  const vm = this

  vm.accessory = accessory

  vm.accessoryTypes = ACCESSORY_TYPES

  vm.accessoryTypesForSelect = [...Object.keys(ACCESSORY_TYPES), null]

  accessory.currency = accessory.currency ? findIn(networkCurrencies)(accessory.currency) : networkCurrencies[0]

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddAccessoryCtrl
   * @type {Boolean}
   */
  vm.isNew = accessory._isNew()

  /**
   * Checkbox if prefix is autogenerated
   *
   * @memberof mwApp/packages.controller:AddAccessoryCtrl
   * @type {Boolean}
   */
  vm.autoIdentifier = !accessory.identifier

  vm.currencies = networkCurrencies

  vm.onChangeCurrencyMessage = `This accessory is assigned to the Subscription(s) ${vm.accessory.assignedSubscriptionNames.join(', ')}. ` +
    'Accessories can be assigned to Subscription only in Subscription Currency. If You change Accessory currency, it will be unassigned. Pricing rules with this accessory, if exist, will be changed or deleted too.<br><br>' +
    'Are You sure You want to change Accessory currency?'

  vm.changeCurrency = function (currency) {
    vm.accessory.currency = currency
    $scope.form.$setDirty()
  }

  vm.submit = function () {
    accessory.identifier = (!vm.autoIdentifier && accessory.identifier.toUpperCase()) || null
    vm.setDisable()

    accessory._save()
      .then(vm.location(accessory).reload)
      .finally(vm.unsetDisable)
  }

  /**
   * Delete Accessory
   *
   * @memberof mwApp/packages.controller:AddAccessoryCtrl
   */
  vm.delete = function () {
    vm.setDisable()
    accessory._delete()
      .then($location.url(pckg._publicUrl + '/monetization-plans#accessories'))
      .finally(vm.unsetDisable)
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddAccessoryCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(pckg._publicUrl + '/monetization-plans#accessories')
    }
  }
}
